import { useEffect, useRef, useState, useCallback } from 'react'

function getEndTimeBySeconds(s: number) {
  return Date.now() + s * 1000
}

function division(n1: number, n2: number) {
  const r1 = Math.floor(n1 / n2)
  const r2 = n1 % n2
  return [r1, r2]
}

const secondMS = 1
const minMs = 60 * secondMS
const hourMs = 60 * minMs
const dayMs = hourMs * 24

const emptyFun = () => {}

/**
 * 是个递归过程
 * @param time
 */
function getLeftTimeHMS(time: number) {
  const [d, lefth] = division(time, dayMs)
  const [h, left] = division(lefth, hourMs)
  const [m, left1] = division(left, minMs)
  const [s] = division(left1, secondMS)
  return [d, h, m, s]
}

function useCountDown(props: { seconds: number; onTimeEnd: () => void }) {
  // // 第一次的值不为 空
  // const originSeconds = useRef(props.seconds || 0);
  // 保证第一次不为空可以倒计时
  const originSeconds = useRef(0)
  const endTime = useRef(getEndTimeBySeconds(props.seconds))
  const interval = useRef<null | (() => void)>(null)
  const leftTimeRef = useRef(0)
  const [leftTime, setLeftTime] = useState(0)
  const propsRef = useRef({
    onTimeEnd: emptyFun,
  })

  useEffect(() => {
    propsRef.current.onTimeEnd = props.onTimeEnd
  }, [props.onTimeEnd])

  const setIntervalCb = useCallback((time) => {
    if (time >= 0) {
      if (interval.current! == null) {
        interval.current = () => {
          let now = Date.now()
          const diff = endTime.current - now
          const diffSeconds = Math.floor(diff / 1000)
          if (diffSeconds >= 0) {
            if (leftTimeRef.current !== diffSeconds) {
              leftTimeRef.current = diffSeconds
              setLeftTime(diffSeconds)
            }
            if (interval.current !== null && typeof interval.current === 'function') {
              // console.error('倒计时中。。。。');
              // setTimeout(() => {
              //   if (interval.current !== null) {
              //     interval.current()
              //   }
              // }, 300)
              requestAnimationFrame(interval.current)
            }
          } else {
            if (originSeconds.current !== 0 && typeof propsRef.current.onTimeEnd === 'function') {
              propsRef.current.onTimeEnd()
            }
            setLeftTime(0)
          }
        }
        interval.current()
      }
    } else {
      setLeftTime(0)
      leftTimeRef.current = 0
    }
  }, [])

  useEffect(() => {
    if (originSeconds.current !== props.seconds) {
      originSeconds.current = props.seconds
      endTime.current = getEndTimeBySeconds(props.seconds)
      setIntervalCb(endTime.current)
    }
    return () => {
      interval.current = null
    }
  }, [props.seconds])

  const [d, h, m, s] = getLeftTimeHMS(leftTime)

  // console.log('render.......');

  return {
    leftTime,
    setLeftTime,
    h,
    m,
    s,
    d,
  }
}

export default useCountDown
